const predictiveForm = document.querySelector('[data-predictive-search-form]');
const predictiveInput = predictiveForm?.querySelector('[data-predictive-search-input]');
const predictiveResults = predictiveForm?.querySelector('[data-predictive-search-results]');
let predictiveTimer;

predictiveInput?.addEventListener('input', () => {
  clearTimeout(predictiveTimer);
  const query = predictiveInput.value.trim();
  if (query.length < 2) {
    predictiveResults.hidden = true;
    predictiveResults.replaceChildren();
    return;
  }
  predictiveTimer = setTimeout(async () => {
    const root = window.Shopify?.routes?.root || '/';
    const url = `${root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,page&resources[limit]=6&section_id=predictive-search`;
    const response = await fetch(url);
    if (!response.ok) return;
    const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
    const panel = nextDocument.querySelector('.predictive-search-panel');
    predictiveResults.replaceChildren(...(panel ? [panel] : []));
    predictiveResults.hidden = !panel;
  }, 180);
});

document.addEventListener('click', (event) => {
  if (predictiveForm && !predictiveForm.contains(event.target)) predictiveResults.hidden = true;
});

const loadMore = document.querySelector('[data-load-more]');
loadMore?.addEventListener('click', async (event) => {
  event.preventDefault();
  loadMore.setAttribute('aria-busy', 'true');
  const response = await fetch(loadMore.href);
  if (!response.ok) { loadMore.removeAttribute('aria-busy'); return; }
  const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
  const nextGrid = nextDocument.querySelector('[data-infinite-grid]');
  const nextLink = nextDocument.querySelector('[data-load-more]');
  document.querySelector('[data-infinite-grid]')?.append(...(nextGrid ? [...nextGrid.children] : []));
  if (nextLink) {
    loadMore.href = nextLink.href;
    loadMore.removeAttribute('aria-busy');
  } else {
    loadMore.remove();
  }
});
